import { z } from "zod";

export enum UserRole {
  USER = "user",
  ADMIN = "admin",
  MODERATOR = "moderator",
}

export type UserPreferences = {
  displayName?: string;
  profession?: string; // User's job or profession
  responseStyleExample?: string; // Example of preferred response style
};

export type User = {
  id: string;
  name: string;
  email: string;
  image: string | null;
  role: UserRole;
  preferences?: UserPreferences;
  isDealStudioCustomer?: boolean;
  preferredTheme?: string;
};

export type UserRepository = {
  existsByEmail: (email: string) => Promise<boolean>;
  updateUser: (id: string, user: Pick<User, "name" | "image">) => Promise<User>;
  updatePreferences: (
    userId: string,
    preferences: UserPreferences,
  ) => Promise<User>;
  getPreferences: (userId: string) => Promise<UserPreferences | null>;
  findById: (userId: string) => Promise<User | null>;
  getDealStudioStatus: (userId: string) => Promise<boolean>;
  setDealStudioStatus: (
    userId: string,
    isDealStudioCustomer: boolean,
  ) => Promise<User>;
  getPreferredTheme: (userId: string) => Promise<string | null>;
  setPreferredTheme: (userId: string, theme: string) => Promise<User>;
  deleteUser: (userId: string) => Promise<void>;
  listUsers: (limit?: number, offset?: number) => Promise<User[]>;
  updateRole: (userId: string, role: string) => Promise<User>;
};

export const UserZodSchema = z.object({
  name: z.string().min(1),
  email: z.string().email(),
  password: z.string().min(8),
});

export const UserPreferencesZodSchema = z.object({
  displayName: z.string().optional(),
  profession: z.string().optional(),
  responseStyleExample: z.string().optional(),
});
